// encryptUrl.js
// ✅ Link ab backend par JWT se banta hai aur 2 din me khud expire hota hai.
//    Frontend sirf token backend ko bhejta hai aur data wapas leta hai.
// ✅ Purane exports (encryptParams / decryptParams / buildCertificateUrl) bhi
//    yahin rakhe hain taki purani files ka build na toote.

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

/* ═══ NEW — server verified token ═══ */

/** URL se token nikalo — naya ?token= ya purana ?d= dono chalenge */
export function getTokenFromUrl(search = window.location.search) {
  const p = new URLSearchParams(search);
  return p.get("token") || p.get("d") || "";
}

/**
 * resolveCertificate(token)
 * -> { ok, certificate, expiresAt, code, message, portalUrl }
 * code: EXPIRED | INVALID | SUPERSEDED | REVOKED | LIMIT_EXCEEDED | NOT_APPROVED | ALREADY_USED | NETWORK
 */
export async function resolveCertificate(token) {
  try {
    const res  = await fetch(`${API_BASE}/validate-token?token=${encodeURIComponent(token)}`);
    const data = await res.json();

    if (!data.success) {
      return {
        ok: false,
        code: data.code || (data.alreadyUsed ? "ALREADY_USED" : "INVALID"),
        message: data.message,
        portalUrl: data.portalUrl,
      };
    }

    return {
      ok: true,
      certificate: data.student,   // { name, email, course, months, completionDate, verifyId, jti }
      expiresAt:   data.expiresAt,
    };
  } catch {
    return { ok: false, code: "NETWORK", message: "Server se connect nahi ho pa raha." };
  }
}

/** PDF ban jane ke baad download count badhane ke liye */
export async function markDownloaded(token) {
  try {
    const res = await fetch(`${API_BASE}/mark-token-used`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });
    return await res.json();
  } catch {
    return { success: false };
  }
}

/** Email se apne saare approved certificates (self-service page) */
export async function fetchMyCertificates(email) {
  try {
    const res = await fetch(`${API_BASE}/my-certificate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });
    return await res.json();
  } catch {
    return { success: false, code: "NETWORK", message: "Server se connect nahi ho pa raha." };
  }
}

/** "1 day 4 hr left" */
export function timeLeftLabel(expiresAt) {
  if (!expiresAt) return "";
  const ms = new Date(expiresAt).getTime() - Date.now();
  if (ms <= 0) return "Expired";
  const h = Math.floor(ms / 3600000);
  const d = Math.floor(h / 24);
  if (d >= 1) return `${d} day${d > 1 ? "s" : ""} ${h % 24} hr left`;
  const m = Math.floor((ms % 3600000) / 60000);
  return `${h} hr ${m} min left`;
}

/* ═══════════════════════════════════════════════════════
   LEGACY — purane XOR links / purane imports ke liye
   (in par naya kaam mat banao, sirf build tootne se bachane
    aur purane links khulne ke liye hain)
   ═══════════════════════════════════════════════════════ */
const LEGACY_KEY = "UNCODEMY_CERT_2024";

function xorCipher(str, key) {
  let out = "";
  for (let i = 0; i < str.length; i++) {
    out += String.fromCharCode(str.charCodeAt(i) ^ key.charCodeAt(i % key.length));
  }
  return out;
}

/** purana encrypt — ab sirf backward compatibility ke liye */
export function encryptParams(paramsObj) {
  const json   = JSON.stringify(paramsObj);
  const xored  = xorCipher(json, LEGACY_KEY);
  const base64 = btoa(unescape(encodeURIComponent(xored)));
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

/** ✅ purana naam — ye hi missing tha, isi se build fail ho raha tha */
export function decryptParams(encryptedStr) {
  try {
    let base64 = String(encryptedStr || "").replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4 !== 0) base64 += "=";
    const xored = decodeURIComponent(escape(atob(base64)));
    const data  = JSON.parse(xorCipher(xored, LEGACY_KEY));
    if (data && data.exp && Date.now() > data.exp) return null;  // 2-din rule yahan bhi
    return data;
  } catch {
    return null; // invalid / tampered token
  }
}

/** alias — naya naam */
export const decryptLegacyParams = decryptParams;

/** purana helper — ab backend link banata hai, ye sirf compatibility ke liye */
export function buildCertificateUrl(baseUrl, paramsObj) {
  return `${baseUrl}?d=${encryptParams(paramsObj)}`;
}